import React from 'react';
import { get } from 'lodash-es';

import { BulkActions } from '../../../../enums/bulk-actions';
import { PackingSlipTemplateDropdown } from './packing-slip-dropdown';

export const PackingSlipTemplate = {
  id: BulkActions.packingSlipTemplate.name,

  render: (onChange, model) => {
    const templates = get(model, 'templates');
    const packingSlipTemplateId = get(templates, 'packingSlipTemplateId');
    return (
      <PackingSlipTemplateDropdown
        dropdownMenuShouldHaveWidthOfButton
        onItemSelected={(newPackingSlipTemplateId) => {
          onChange({
            ...model,
            templates: {
              ...templates,
              packingSlipTemplateId: newPackingSlipTemplateId,
            },
          });
        }}
        selectedPackingSlipTemplateId={packingSlipTemplateId}
      />
    );
  },
};
